<!-- Iteramos los nodos dentro de la fila -->
<!-- Si el node tiene routeId = nodo real, si no = hueco -->
<shared-route-chart-box [value]="node" [ngClass]="node.classString"
    [ngStyle]="{ width: 'calc(12em * ' + node.percentatge + ')' }"
    *ngFor="let node of value.nodes"></shared-route-chart-box>